/**
 * CSRF Token Management
 *
 * Provides utilities for getting and using CSRF tokens in AJAX requests.
 * The token is set globally by the layout template as window.csrfToken.
 */

/**
 * Get the CSRF token from the global window object or meta tag
 * @returns {string} The CSRF token
 */
export function getToken() {
    // First try window.csrfToken (set by layout)
    if (window.csrfToken) {
        return window.csrfToken;
    }

    // Fallback to meta tag
    const metaTag = document.querySelector('meta[name="csrf-token"]');
    if (metaTag) {
        return metaTag.getAttribute('content');
    }

    // Fallback to hidden input
    const hiddenInput = document.querySelector('input[name="_token"]');
    if (hiddenInput) {
        return hiddenInput.value;
    }

    console.warn('CSRF token not found');
    return '';
}

/**
 * Get headers object with CSRF token for fetch requests
 * @param {Object} additionalHeaders - Additional headers to include
 * @returns {Object} Headers object with CSRF token
 */
export function getHeaders(additionalHeaders = {}) {
    return {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': getToken(),
        ...additionalHeaders
    };
}

/**
 * Add CSRF token to a data object for form submission
 * @param {Object} data - Data object to add token to
 * @returns {Object} Data object with _token added
 */
export function addTokenToData(data = {}) {
    return {
        ...data,
        _token: getToken()
    };
}

export default {
    getToken,
    getHeaders,
    addTokenToData
};
